import './newsletter.scss';
import { $store, $channels } from '@/ts/store';
import { debounce } from '@/ts/utilities';
import { EMAIL_VALIDATION } from '@/ts/enums';

/*
* This function create for newsletter component and integrated logic for accessibility.
* */

export default function Newsletter() {
    const $target = document.querySelector('.newsletter') as HTMLElement;

    if ($target) {
        const $form = $target.querySelector('form.email-container')!;

        const $placeholder = $form.querySelector('.input-text') as HTMLElement;
        const $email = $form.querySelector('input.input') as HTMLInputElement;
        const $termsCheckbox = $form.querySelector('input.checkbox') as HTMLInputElement;
        const $submit = $form.querySelector('button.email-button') as HTMLButtonElement;

        const $icnError = $form.querySelector('.error-icn') as HTMLElement;
        const $error = $form.querySelector('.error-wrapper') as HTMLElement;

        const storeKey = 'newsletter-subscription';
        let newsletterState = {
            email: '',
            isEmailValid: false,
            termsAccepted: false,
            $form: $form,
            toggleSpinner,
            confirmSubscription,
            failureSubscription,
        };

        $channels.register(storeKey);

        function isEmailValid(email: string): boolean {
            return !!email.match(EMAIL_VALIDATION);
        }

        function confirmSubscription() {
            const $subscription = $target.querySelector('.subscription--completed') as HTMLElement;
            $target.classList.add('is-success');
            $subscription.innerHTML = $subscription.innerHTML.replace('#mail#', `<span class="email">${newsletterState.email}</span>`);
        }

        function failureSubscription() {
            const $errorWrapper = $target.querySelector('.error-wrapper');
            const $input = $target.querySelector('input.input');
            const $erroIcn = $target.querySelector('.error-icn');
            $erroIcn?.classList.add('visible');
            $target.classList.add('failed');
            $input?.classList.add('error');
            $errorWrapper?.classList.add('visible');
        }

        function toggleSpinner(status: boolean) {
            $target.classList.toggle('has-spinner', status);
        }

        function setValueTerms() {
            newsletterState = {
                ...newsletterState,
                termsAccepted: $termsCheckbox.checked,
            };
            $store.setKey(storeKey, { ...newsletterState, termsAccepted: $termsCheckbox.checked });
        }

        function init() {
            $store.setKey(storeKey, { ...newsletterState });

            //Handle submit
            $form.addEventListener('submit', evt => {
                evt.preventDefault();
            });

            //Store input email
            $email.addEventListener(
                'input',
                debounce(() => {
                    newsletterState = {
                        ...newsletterState,
                        isEmailValid: isEmailValid($email.value),
                    };
                    $store.setKey(storeKey, newsletterState);

                    const showError = !newsletterState.isEmailValid && !!newsletterState.email;
                    $error.classList.toggle('visible', showError);
                    $icnError.classList.toggle('visible', showError);
                    $email.classList.toggle('error', showError);
                }, 2000)
            );

            $email.oninput = () => {
                newsletterState = {
                    ...newsletterState,
                    email: $email.value,
                };
                $store.setKey(storeKey, newsletterState);
            };

            //Handle placeholder
            $email.addEventListener('focusin', () => {
                $placeholder.classList.add('visible');
            });
            $email.addEventListener('focusout', () => {
                if (!newsletterState.email) {
                    $placeholder.classList.remove('visible');
                    $email.classList.add('focus-mouse');
                }
            });

            $email.addEventListener('keyup', e => {
                if (e.key === 'Tab' && $email.classList.contains('focus-mouse')) {
                    $email.classList.remove('focus-mouse');
                }
            });

            //Store terms acceptance
            $termsCheckbox.addEventListener('input', () => {
                setValueTerms();
            });

            $termsCheckbox.addEventListener('keypress', (e: KeyboardEvent) => {
                if (e.key === 'Enter') {
                    $termsCheckbox.toggleAttribute('checked');
                    setValueTerms();
                }
            });

            //Handling submit button activation
            $channels.attach(storeKey, (state: Record<string, any>) => {
                $submit.toggleAttribute('disabled', !state.isEmailValid || !state.termsAccepted);
            });
        }

        init();
    }
}
